import React from "react";
import { FaReact, FaNodeJs, FaPython, FaJava, FaAws } from "react-icons/fa";
export default function Service() {
 const techData = [
   {
     name: "Java",
     icon: <FaJava />,
     desc: "Robust, object-oriented programming language widely used in enterprise applications.",
   },
   {
     name: "Python",
     icon: <FaPython />,
     desc: "A high-level, versatile programming language known for AI and data science.",
   },
   {
     name: "Node.js",
     icon: <FaNodeJs />,
     desc: "JavaScript runtime built on Chrome's V8 engine for scalable server-side apps.",
   },
   {
     name: "React JS",
     icon: <FaReact />,
     desc: "A JavaScript library for building fast and interactive UIs.",
   },
   {
     name: "React Native",
     icon: <FaReact />,
     desc: "A framework for building native mobile apps using React.",
   },
   {
     name: "AWS",
     icon: <FaAws />,
     desc: "Amazon Web Services provides scalable cloud infrastructure and services.",
   },
 ];
  return (
    <>
    
      {/* 1 section */}

      <div className="technology" style={{ marginTop: "-120px" }}>
        <div className="features">
          <div className="feature-heading" data-aos="fade-up">
            <h1>Services</h1>
          </div>
          <p data-aos="fade-up">
            Necessitatibus eius consequatur ex aliquid fuga eum quidem sint
            consectetur velit
          </p>
        </div>
        <div className="tech-cards"  style={{marginTop:"-50px"}} data-aos="fade-up">
          {techData.map((tech, idx) => (
            <div key={idx} className="tech-card">
              <div className="tech-icon" title={tech.name}>
                {tech.icon}
              </div>
              <h3>{tech.name}</h3>
              <p className="tech-desc">{tech.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
